<template>
  <el-dialog
    v-if="dialogVisible"
    class="load-contract-oracle-dialog common-dialog"
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    :before-close="handleCancel"
    :title="title"
    top="20vh"
  >
    <div class="chain-contract-wrapper">
      <template v-for="(item, index) in Chains" class="chain-contract-item">
        <detail-section :key="index" :title="item.ChainID" :show-border="true">
          <div class="info-content">
            <div class="contract-item">
              <div class="contract-text">
                default oracle contract
              </div>
              <div class="fill"></div>
              <div class="contract-btn">
                <el-button v-if="item.DefaultOracleContractInstalled" type="success" class="btn-box"
                  >已安装</el-button
                >
                <el-button
                  v-else
                  type="primary"
                  class="btn-box"
                  @click="handleInstall(1, item.ChainID, item.OracleID, index)"
                  >未安装,点击安装</el-button
                >
              </div>
            </div>
            <div class="contract-item">
              <div class="contract-text">
                default user contract
              </div>
              <div class="fill"></div>
              <div class="contract-btn">
                <el-button v-if="item.DefaultUserContractInstalled" class="btn-box" type="success"
                  >已安装</el-button
                >
                <el-button
                  v-else
                  class="btn-box"
                  type="primary"
                  @click="handleInstall(2, item.ChainID, item.OracleID, index)"
                  >未安装,点击安装</el-button
                >
              </div>
            </div>
          </div>
        </detail-section>
      </template>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'ContractDialog',
  data() {
    return {
      disabled: false,
      dialogVisible: false,
      Chains: [],
      title: '安装默认合约',
      editRule: {
        Addr: [{ required: true, message: '请输入服务地址', trigger: 'blur' }]
        // port: [
        //   { required: true, message: '请输入服务端口', trigger: 'blur' },
        //   { pattern: /^(102[5-9]|10[3-9]\d|[2-9]\d{3,})$/, message: '请正确输入端口', trigger: 'blur' }
        // ],
      }
    }
  },

  mounted() {},
  methods: {
    //安装部署合约
    handleInstall(ContractType, ChainID, OracleID, index) {
      this.disabled = true
      let params = {
        ContractType,
        ChainID,
        OracleID
      }
      this.$apis.oracleManagement
        .installDefaultContract(params)
        .then(res => {
          if (res) {
            this.$message.success(ChainID + '安装默认合约成功')
            if (ContractType == 1) {
              this.Chains[index].DefaultOracleContractInstalled = true
            } else {
              this.Chains[index].DefaultUserContractInstalled = true
            }
            this.disabled = false
          } else {
            this.disabled = false
          }
          this.handleCancel()
        })
        .catch(err => {
          this.disabled = false
        })
    },

    handleOpen(data) {
      this.dialogVisible = true
      this.Chains = data.Chains
    },

    handleCancel() {
      this.dialogVisible = false
      this.$emit('update:list')
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';
.load-contract-oracle-dialog.common-dialog {
  @include adaptation(
    (
      --common-dialog-content-max-height: 420px
    )
  );
  /deep/ .el-dialog {
    width: var(--common-dialog-medium-width);
  }

  .chain-contract-wrapper {
    max-height: var(--common-dialog-content-max-height);
    overflow-y: auto;

    .info-content {
      padding: var(--base-size-20);

      .contract-item {
        display: flex;
        align-items: center;

        &:not(:last-child) {
          margin-bottom: var(--base-size-16);
        }

        .fill {
          flex-grow: 1;
        }
      }
    }
  }
}
</style>
